module.exports = __webpack_public_path__ + "static/media/ic-close-small-white.13046f98.svg";